import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor(private httpClient: HttpClient) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common/state"

  getModify(stateid): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/getmodify/${stateid}`);
  }
  getData(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getdata`);
  }
  addState(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/addstate`, payload);
  }
  modifyState(payload): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/modifystate`, payload);
  }

  getCountry(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getcountry`);
  }
}
